import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject("specialOfferStore")
@observer
class SearchMenuItemModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'In Room Dining',
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: 'Category',
                dataIndex: 'categoryName',
                key: 'categoryName',
                width: '40%'
            },
            {
                title: 'Action',
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectSearchMenuItemClicked(taskId)} type="primary">
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    searchChanged = e => {
        this.props.specialOfferStore.setItemSearchValue(e.target.value);
        this.props.specialOfferStore.searchItem();
    }

    selectSearchMenuItemClicked = taskId => {
        this.props.specialOfferStore.searchItemSelected(taskId);
        this.props.specialOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.specialOfferStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder="Search In Room Dining" value={itemSearchValue} onChange={this.searchChanged} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default SearchMenuItemModal